import React, { Fragment } from "react";
import Loader from "../loader";
import moment from "moment";
import lodash from 'lodash';
import Config from "../../../config/main";
import HorseRacingEventWrapper from "../horseRacingEventsWrapper";
import {t} from "../../../helpers/translator";

export default function horseRacingGameTimesTemplate () {
    const { data, loaded, params: { gameId }, newData } = this.props;
    const { day, selectedGameId } = this.state;
    if (data && loaded) {
        return <Fragment>
            <div className="upcoming-h-row-d">
                <ul>
                    {
                        Object.keys(newData).map(gameDate => <li key={gameDate} onClick={() => this.handleDayClick(gameDate)} >
                            <div className={`h-r-time-b ${(day === gameDate) ? "active" : ""}`}>{gameDate}</div>
                        </li>)
                    }
                </ul>
            </div>
            <Fragment>
                <div className="upcoming-h-row">
                    <ul>
                        <li>
                            <h4>{t("UPCOMING RACES")}</h4>
                        </li>
                        {
                            Object.values(newData[day] || {}).map(game => <li key={game.id} onClick={() => this.handleGameClick(game.id)} >
                                <div className={`h-r-time-b ${(gameId === (game.id || -1).toString()) ? "active" : ""}`}>{moment.unix(game.start_ts).format(Config.main.timeFormat)}</div>
                            </li>)
                        }
                    </ul>
                </div>
                <HorseRacingEventWrapper gameInfo={data.find(item => (item.id || -1).toString() === selectedGameId) || {}} />
            </Fragment>
        </Fragment>;
    }
    return <Loader />;
}